import './style';
import './vendor';

import './dataTables';
import './i18n/local-time.sv';
import './remote-modal';

require("expose-loader?Tryckhuset!./tryckhuset");
